import React from "react";

const DashCounterIcon = ({
  width = 14,
  height = 2,
  color = "none",
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 14 2"
    fill="none"
  >
    <path
      d="M12.8662 0.865234H0.866211"
      stroke="currentColor"
      stroke-width="1.73205"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default DashCounterIcon;
